
import { computed, defineComponent, reactive } from 'vue';
import { Card } from 'ant-design-vue';
import { IPedidoCompraImposto } from '@/models/Entidades/Compras/IPedidoCompra';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';

export default defineComponent({
  name: 'PedidoCompraImpostos',
  props: {
    impostos: {
      type: Object as () => IPedidoCompraImposto,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Card,
    CampoNumerico,
  },
  emits: ['update:impostos', 'totalAlterado'],
  setup(props, { emit }) {
    const state = reactive({});

    const computedImpostos = computed({
      get: () => props.impostos,
      set: (val: IPedidoCompraImposto) => {
        emit('update:impostos', val);
      },
    });

    function totalAlterado() {
      emit('totalAlterado');
    }

    return {
      props,
      state,
      computedImpostos,
      totalAlterado,
    };
  },
});
